module.exports = __webpack_public_path__ + "img/home-bg.36ffc2fa.png";